import React from 'react'
import RecordSection from './_RecordSection'
import InfoLine from './_InfoLine'

const Safeguarding = ({ epcr }) =>
  epcr.safeguarding?.concerns ? (
    <RecordSection title="Safeguarding">
      <InfoLine label="Concerns" value={epcr.safeguarding.concernsDetails} />
      <InfoLine
        label="Discussed With"
        value={epcr.safeguarding.discussedWith.join(', ')}
      />
      <InfoLine
        label="Referral Made"
        value={epcr.safeguarding.referralMade ? 'Yes' : 'No'}
      />
      <InfoLine label="Referral Info" value={epcr.safeguarding.referralInfo} />
    </RecordSection>
  ) : null

  export default Safeguarding
